import { Component, OnInit, HostListener } from '@angular/core';
import { AuthenticationService } from 'app/shared/services/authenticationService';
import { Router, ActivatedRoute } from '@angular/router';
import { EventAggregator, EventList } from 'app/shared/utility/EventAggregator';
import { Role } from 'app/shared/common/role';
import { User } from 'app/shared/models/userModel';
import { AppInsightService } from 'app/shared/services/app-insight.service';
@Component({
  selector: 'app-login-register',
  templateUrl: './login-register.component.html',
  styleUrls: ['./login-register.component.css']
})
export class LoginRegisterComponent implements OnInit {
  submitterName = '';
  selectedSubmitterModel: Array<any>;
  selectedOrganizationsModel: Array<any> = [];
  userTypeModel: Array<any> = [];
  submitterNames: Array<any> = [];
  public loginState = true;
  public resetState = false;
  public oldPassword: string;
  public passwordReset: string;
  public confirmPasswordReset: string;
  public confirmPassword: string;
  public user: User = new User();
  public role = Role;
  disable: boolean = false;
  // public roles: [string, string][] = Role
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService,
    private appInsightService: AppInsightService
  ) {}

  private clearFields() {
    this.oldPassword = '';
    this.passwordReset = '';
    this.confirmPassword = '';
    this.confirmPasswordReset = '';
  }
  private checkScreenSize() {
    if (window.innerWidth < 600) {
      this.disable = true;
    } else {this.disable = false; }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkScreenSize();
  }

  ngOnInit() {
    this.checkScreenSize();
    if (this.authService.isAuthenticated()) {this.router.navigate(['/dashboard']); }

    this.activatedRoute.params.subscribe(params => {
      let val = params['invalidSession'];
      if (val) {
        EventAggregator.publish(EventList.popupTriggered, {
          type: 'alertMessage',
          value: { msg: 'Session Expired' }
        });
      }
    });

  }

  login() {
    this.authService
      .authenticate(this.user.Email, this.user.Password)
      .then(isTempPassword => {
        this.appInsightService.setUserId(this.user.Email);
        if (isTempPassword) {
          this.oldPassword = this.user.Password;
          this.resetState = true;
        }
      });
  }

  register() {

    this.authService
      .createUser( this.user)
      .then(result => {

        if (result.Success) {
          EventAggregator.publish(EventList.popupTriggered, {
            type: 'alertMessage',
            value: {
              title: 'Registration Complete',
              msg: 'User account created. You will receive an email shortly to confirm your email address.'
            }
          });
          this.clearFields();
          this.loginState = true;
          this.resetState = false;
        } else {
          let errStr = result.Errors.reduce(
            (accu, current) => accu + (current + '<br/>'),
            ''
          );
          EventAggregator.publish(EventList.popupTriggered, {
            type: 'alertMessage',
            value: { msg: errStr }
          });
        }
      })
      .catch(_ => { });
  }

  resendConfirmation() {
    this.authService
      .requestConfirmationEmail(this.user)
      .then(result => {

        if (result.Success) {
          EventAggregator.publish(EventList.popupTriggered, {
            type: 'alertMessage',
            value: {
              title: 'Email Sent',
              msg: 'Confirmation email sent.'
            }
          });
          this.clearFields();
          this.loginState = true;
          this.resetState = false;
        } else {
          let errStr = result.Errors.reduce(
            (accu, current) => accu + (current + '<br/>'),
            ''
          );
          EventAggregator.publish(EventList.popupTriggered, {
            type: 'alertMessage',
            value: { msg: errStr }
          });
        }
      })
      .catch(_ => { });
  }

  forgotPassword() {
    if (!this.user.Email) {
      EventAggregator.publish(EventList.popupTriggered, {
        type: 'alertMessage',
        value: { msg: 'Please input your email address.' }
      });
    } else {
      this.authService.forgotPassword(this.user.Email);
    }
  }

  resetPassword() {
    this.authService
      .resetPassword(
        this.oldPassword,
        this.passwordReset,
        this.confirmPasswordReset
      )
      .then(res => {
        switch (res.type) {
          case Role.Admin:
            this.router.navigate(['/admin']);
            break;
          case Role.User:
            this.router.navigate(['/landingPage']);
            break;
          default:
            EventAggregator.publish(EventList.popupTriggered, {
              type: 'alertMessage',
              value: { msg: 'User does not have a valid user type' }
            });
            break;
        }
      });
  }
}